<template>
	<!-- 注册协议 -->
	<div class="registXyBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- back -->
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">云锦文学城用户注册协议</p>
				</div>
			</div>
		</van-sticky>
		<div class="txt">
			<p>更新时间：2020年10月1日</p>
			<p>生效时间：2020年10月1日</p>
			<h4>首部及导言</h4>
			<p>欢迎您注册云锦文学城，在您成功注册成为我们的用户后，您将有权利享有我们提供的相应服务，但同时也请遵守我们相关的网站规则并履行一定的义务。请您在注册之前务必认真阅读以下全部服务协议条款，如有任何疑问，可向我们咨询。您一旦注册成为我们的用户，即表示完全接受本协议全部条款。</p>
			<p>本站有权在必要时变更用户协议，而无需事先通知。用户协议变更后使用本站者，视为接受变更后的用户协议</p>
			<p>您确认您具备完全民事权利能力和完全民事行为能力，有能力同意并遵守本协议，并对本协议项下*的全部行为独立承担法律责任。若您不具备前述与您行为相适应的民事行为能力，则应获得法定监护人的知情同意。如您尚未成年，请在法定监护人的陪同下阅读和判断是否同意本协议，未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可。</p>
			<h4>一、服务说明：</h4>
			<p>1.1西安云卷云书网络科技有限责任公司及旗下运营的小说原创网络平台云锦文学城将为您提供包括但不限于如下服务：</p>
			<p>1.1.1云锦文学城小说阅读原创网络平台，包括但不限于www.yjwxc.com等域名下的网站和安卓、iOS等系统版本的各种客户端。</p>
			<p>1.1.2在云锦文学城阅读小说、充值、写作、收益提现。</p>
			<p>1.2 云锦文学城所提供的服务，均限于在1.1.2所述平台（以下简称“云锦文学城”）内使用，任何以恶意破解等非法手段将云锦文学城所提供的服务与云锦文学城平台分离的行为，皆不属于本协议约定的由云锦文学城提供的服务。由此引起的一切后果由行为人承担，云锦文学城将保留依法追究行为人法律责任的权利。</p>
			<h4>二、账号与密码</h4>
			<p>2.1登入云锦文学城域名（www.yjwxc.com）或通过云锦文学城官方公布的方式注册、登入，下载客户端（包括但不限于iOS、Android等智能平台），是使用云锦文学城服务的合法方式。用户通过其他任何途径、任何渠道、任何方式获取的云锦文学城服务（包括但不限于账号、云锦币、客户端下载等）均为非法所得，云锦文学城概不承认其效力，且一经发现，云锦文学城有权立即作出删除、清零、封号等处理，因此导致的一切不利后果均由用户自行承担。请用户妥善保管自己的账号和密码，加强密码安全性，谨防账号泄露或被盗。因用户账号被泄露或被盗而造成的任何损失，云锦文学城不承担责任。</p>
			<p>2.2 您须在注册时提供自己的真实信息，诸如电子邮件地址、手机号码等，并保证信息的有效性及安全性，保证云锦文学城可以通过上述联系方式与您进行联系。同时，您也须在相关信息变更时及时更新有关注册信息。请您保证不以他人信息在云锦文学城进行注册或认证。如果因注册信息不真实或者更新不及时而引发的相关问题，本站不负任何责任。</p>
			<p>2.3云锦文学城账号使用权仅属于初始注册用户，未经云锦文学城书面同意，您不得以任何形式处置账号的使用权（包括但不限于赠与、出借、转让、销售、抵押、继承、许可他人使用）。如果云锦文学城发现或者有合理理由认为使用者并非账号初始注册人，云锦文学城有权在不通知的情况下，暂停或终止向该注册账号提供服务，并注销该账号。由此带来的虚拟货币及其他损失由您自行承担。</p>
			<p>2.4单个用户最多可注册3个云锦文学城账号。如单个用户注册云锦文学城账号数量超过3个，则云锦文学城有权随时停止对超出数量限制的账号的部分或全部服务。</p>
			<h4>三、收费及充值</h4>
			<p>3.1您理解并同意，云锦文学城提供的部分服务为收费服务，且有权自行决定并修改相关的收费标准和规则，或对服务内容进行变更，无论您是否购买。前述修改、变更前，云锦文学城将在相应服务页面进行通知或公告，该类标准及规则一经发布即生效。如果您不同意上述标准和规则及其修改，您有权停止使用本服务。</p>
			<p>3.2由于云锦文学城网站的作品由作者独立创作，无论您是否购买作品的收费章节，作者都有权对作品及文案进行修改。用户购买收费章节后，自用户购买之日起一年内可阅读。超过期限后，云锦文学城将尽最大努力无偿地为您延长阅读期限，使您可以继续阅读您已购买的收费章节。但请您知悉并理解：如小说收费章节或全本因版权纠纷、作者或作品自身原因（如违反法律法规、政策的规定或行业的规则、涉及侵权纠纷、违反公序良俗等）或其他原因导致作品下架、被屏蔽无法正常阅读的，云锦文学城不承担任何责任。</p>
			<p>3.3您可以通过云锦文学城官方提供的充值渠道进行充值，充值后您可获得对应的产品“云锦币”。完成充值行为后进行消费行为的，对于已消费的金额，云锦文学城不予退还。用户就用户账户中尚未消费的充值金额申请退款的，可联系客服并配合提供相关证明材料，云锦文学城会对该用户的退款事宜进行审核。如审核通过的，将会根据用户充值时选取的支付手段或其他双方协商认可的渠道将相应充值金额返还给用户，并扣除对应手续费。如您充值时获得赠送云锦币的，赠送云锦币需在退款时全部退还至云锦文学城。</p>
			<p>3.4您因自身操作不当或未充分了解充值计费方式等因素造成的数额充值错误、账号充值错误等，云锦文学城不予退费、补偿或赔偿。若因云锦文学城充值系统自身故障造成您充值失实，在云锦文学城恢复、存有有效数据和您提供合法有效凭证的情况下，云锦文学城将根据您充值情况作出变动及补救措施。若因云锦文学城充值系统自身故障原因，造成系统充值额小于您实际充值额的，云锦文学城予以补其差额。因云锦文学城充值系统自身故障原因，造成系统充值额大于您实际充值额的，云锦文学城有权追回差额。</p>
			<p>3.5您不得以盗窃、利用系统漏洞等非法途径以及在未获云锦文学城授权的非法销售云锦币的渠道上获取或购买云锦币，否则云锦文学城有权在不通知您的情况下对账户进行封禁处理，账户中的虚拟货币不退还，由此引发的后果由您自行承担，云锦文学城不承担任何责任。</p>
			<p>3.6 您理解并同意，您购买的VIP收费章节或赠送礼物的云锦币支出，云锦文学城将不提供任何订单更改、修正服务。非经云锦文学城同意，您购买的VIP收费章节或赠送礼物的云锦币不会因云锦文学城提供的服务中断、终止或付费作品下架而退还。</p>
			<h4>四、法律声明</h4>
			<p>4.1禁止用户在接受网络服务过程中进行以下侵害行为，包括但不限于：</p>
			<p>（1） 反对宪法确定的基本原则的；</p>
			<p>（2） 危害国家统一、主权和领土完整的；</p>
			<p>（3） 泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；</p>
			<p>（4） 煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；</p>
			<p>（5） 宣扬邪教、迷信的；</p>
			<p>（6） 扰乱社会秩序，破坏社会稳定的；</p>
			<p>（7） 诱导未成年人违法犯罪和宣扬暴力、色情、赌博、恐怖活动的；</p>
			<p>（8） 侮辱或者诽谤他人，侵害他人合法权益的；</p>
			<p>（9） 危害社会公德，损害民族优秀文化传统的；</p>
			<p>（10）有法律、行政法规和国家规定禁止的其他内容的。</p>
			<p>4.2未经云锦文学城许可，不得将云锦文学城的信息用于任何侵犯国家、集体或个人利益的行为或其他商业行为。</p>
			<p>4.3用户不得以任何手段非法篡改、破坏、删除(或有此企图)云锦文学城或数据库中的内容，不得对云锦文学城所属的服务器、系统或网络进行任何形式的攻击、破坏，不得制作、传播病毒。一经发现，我们将立即无限期终止对用户的服务，并报告国家有关行政机关和司法机关，追究用户的法律责任。</p>
			<p>4.4不得利用云锦文学城来获取商业秘密，窥探个人隐私，侵犯他人知识产权，制造、传播和散布污蔑、诽谤、恐吓他人的言论和消息。一经发现，我们将立即无限期终止对用户的服务，并报告国家有关行政机关和司法机关，追究用户的法律责任。</p>
			<p>4.5 禁止用户以任何形式违反诚实信用原则，直接或间接采取组织、教唆、窃取、占有、使用、捡取、购买、转卖等手段侵犯任何第三方拥有使用权的账号、虚拟货币、虚拟物品、虚拟道具等权益；</p>
			<p>4.6禁止用户以任何形式实施影响云锦文学城经营的行为，包括但不限于盗文、刷单、刷分、组织多人用一个账号进行发文等，一经发现，我们将立即无限期终止对用户的服务，并报告国家有关行政机关和司法机关，追究用户的法律责任</p>
			<p>4.7如果您违反了以上约定，相关国家机关或机构要求云锦文学城给予协助，云锦文学城会予以配合。如您违反以上约定，应依法承担责任的，云锦文学城不承担任何责任，因此造成云锦文学城损失的，您应当一并赔偿。如果云锦文学城发现或收到他人举报您发布的信息违反以上约定，云锦文学城有权进行独立判断并采取技术手段予以删除、屏蔽或断开链接。同时，云锦文学城有权视您的行为性质，采取包括但不限于暂停或终止服务，限制、冻结或终止账号使用，追究法律责任等措施。违反以上约定，视为您的严重违约，云锦文学城可以中止对您的服务，解除双方间的服务协议和法律关系，且无需退还您所支付的费用。</p>
			<h4>五、知识产权声明</h4>
			<p>5.1云锦文学城经营者在本服务中使用的商业标识的所有权归云锦文学城经营者所有。云锦文学城经营者是云锦文学城网站及产品中所有信息内容的所有权及知识产权权利人。前述信息内容包括但不限于程序代码、界面设计、版面框架、数据资料、账号、文字、图片、图形、图表、音频、视频等，按照法律法规规定或云锦文学城与权利人约定的应由相关权利人享有权利的内容除外。</p>
			<p>5.2未经云锦文学城许可，禁止复制、下载、上传、修改、翻译、发行、开发、转让、销售、展示、传播云锦文学城网站内容。否则云锦文学城有权在未通知的情况下对账户进行封禁处理，并依法追究用户法律责任。</p>
			<p>5.3未经云锦文学城及相关权利人同意，用户不得对上述功能、软件、服务进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）等行为。</p>
			<h4>六、服务的中断和终止</h4>
			<p>6.1云锦文学城有义务在现有技术上确保网站的正常运行，鉴于网络服务的特殊性，云锦文学城可能变更、中断或终止部分或全部的网络服务（包括收费网络服务及免费网络服务）。如变更、中断或终止网络服务，云锦文学城会尽最大努力提升和改进技术，恢复网络服务的正常运行。</p>
			<p>6.2云锦文学城有权对用户的注册资料进行查阅，发现注册资料中存在任何问题或怀疑，均有权向用户发出询问/要求改正的通知或者直接作出删除等处理。用户如有恶意批量注册的/盗号的/购买的/盗文的/恶意刷收藏订阅等类似的行为的，云锦文学城有权随时将其封禁、删除，并不退回账号内余额。</p>
			<p>6.3您可以依照云锦文学城规定的程序或网站上的提示注销云锦文学城账号。账号注销后，云锦文学城将终止为您提供服务，本协议约定的双方的权利义务终止（依本协议其他条款另行约定不得终止的或依其性质不能终止的除外），同时该账号内已购买的作品不能再阅读，任何产品不能再使用；任何兑换代码（包括但不限于积分或赠币等）都将作废；该账号内余额不能退款或提现。</p>
			<p>6.4除上述原因外，如发生下列任何一种情形，云锦文学城有权不经通知而中断或终止向您提供服务：</p>
			<p>（1）您违反相关法律法规或本协议的约定；</p>
			<p>（2）按照法律规定或主管部门的要求；</p>
			<p>（3）出于安全的原因或其他必要的情形。</p>
			<h4>七、 协议修改</h4>
			<p>7.1云锦文学城有权随时修改本协议的任何条款，一旦本协议的内容发生变动，云锦文学城将会在网站公布修改之后的协议内容。网站各类规则会在发布后生效，成为本协议的一部分。</p>
			<p>7.2如果您不同意云锦文学城对本协议相关条款所做的修改，您有权停止使用云锦文学城服务。如果您登入或继续使用服务，则视为您接受云锦文学城对本协议相关条款所做的修改。除另行明确声明外，任何使该“服务”范围扩大或功能增强的新内容均受本协议约束。</p>
			<h4>八、 通知送达</h4>
			<p>8.1本协议项下云锦文学城对于您所有的通知均可通过注册登录下提醒条款、网页公告、电子邮件、系统通知、私信、手机短信或常规的信件传送等方式进行；通知发送时视为已送达收件人。</p>
			<p>8.2用户对于云锦文学城的通知应当通过云锦文学城对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
			<h4>九、 法律适用</h4>
			<p>9.1本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。</p>
			<p>9.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向西安市雁塔区人民法院提起诉讼。</p>
			<h4>十、 其他规定</h4>
			<p>如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
		</div>
		<!-- 底部 -->
		<div class="footer" v-if="urlStr != ''">
			<button v-for="(item,index) in btn" :key="index" :class="btnindex == index ? 'active' : ''" @click="btnFn(index)">{{item}}</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				btnindex: 1, //按钮选中索引
				btn: ["不同意", "同意"],
				urlStr: '',
			}
		},
		created() {
			this.urlStr = this.$route.query.url || '';
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {
			btnFn(index) {
				this.btnindex = index;
				if (index == 1 && this.urlStr == 'userinfoPage') {
					this.$router.push('/txzl')
				} else if (index == 0 && this.urlStr == 'userinfoPage') {
					this.$router.push('/userinfo')
				} else {
					this.$router.push('/set')
				}
			},
			back() {
				if (this.urlStr == 'userinfoPage') {
					this.$router.push('/userinfo')
				} else {
					this.$router.push('/set')
				}

			}
		}
	}
</script>

<style lang="less" scoped>
	.registXyBox {
		background-color: #fff;
		height: 100vh;
		width: 100vw;
		overflow-x: hidden;
		color: #000;
	}

	// 头部
	.headerBox {
		height: 160px;
		background-color: #FF4081;
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;/*no*/
		.headerQuery {
			margin-top: 80px;
			padding: 0 20px;
			position: relative;
			display: flex;
			width: 100%;
			height: 80px;
			line-height: 80px;
			color: #000;


			.arrImg {
				img {
					width: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 10px;
				}
			}

			.header_titile {
				flex: 1;
				text-align: center;
				font-size: 34px;
				/*px*/
			}
		}

	}

	.txt {
		padding: 10px 30px;
		p{
			line-height: 50px;
			font-size: 26px;/*px*/
		}
		h4{
			line-height: 50px;
			font-size: 28px;/*px*/
		}
	}

	//底部
	.footer {
		position: fixed;
		bottom: 0;
		width: 100vw;
		display: flex;
		border-top: 1px solid #e5e5e5;

		/*no*/
		button {
			flex: 1;
			padding: 30px 0;
			background-color: #fff;
			border: 0;
			color: #3e3e3e;
			font-size: 34px;
			/*px*/
		}

		button.active {
			background-color: #FF4081;
			color: #ffffff;
		}
	}
</style>
